export const FormPageButton = (props) =>  {
    const {text, onClick} = props

    if(typeof onClick === 'function'){
        return (
            <>
                <button className='iPhone5/SE:w-72 w-80 h-16 text-black bg-white font-serif border border-black hover:bg-black hover:text-white' onClick={() => onClick()}>{text}</button>
            </>
        );
    }else{
        return (
            <>
                <button className='iPhone5/SE:w-72 w-80 h-16 text-black bg-white font-serif border border-black hover:bg-black hover:text-white'>{text}</button>
            </>
        );
    }
};